import { createReducer, on, Action } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';

import * as CompaniesActions from './companies.actions';
import { CompaniesEntity } from './companies.models';

export const COMPANIES_FEATURE_KEY = 'companies';

export interface State extends EntityState<CompaniesEntity> {
  selectedId?: string | number; // which Companies record has been selected
  loaded: boolean; // has the Companies list been loaded
  error?: unknown; // last known error (if any)
}

export interface CompaniesPartialState {
  readonly [COMPANIES_FEATURE_KEY]: State;
}

export const companiesAdapter: EntityAdapter<CompaniesEntity> =
  createEntityAdapter<CompaniesEntity>();

export const initialState: State = companiesAdapter.getInitialState({
  loaded: false,
});

const companiesReducer = createReducer(
  initialState,
  on(CompaniesActions.loadCompaniesSuccess, (state, { companies }) =>
    companiesAdapter.setAll(companies, { ...state, loaded: true }),
  ),
  on(CompaniesActions.loadCompaniesFailure, (state, { error }) => ({
    ...state,
    error,
  })),
);

export function reducer(state: State | undefined, action: Action) {
  return companiesReducer(state, action);
}
